import defaultReducer from "./defaultReducer";

const defaultState = {
  selectedOperator: null,
  loading: false,
  selectedProfile: 0,
  grid: {
    data: [],
    rowDef: [],
    headerDef: [],
    span: [],
  },
  activeRow: { id: 0 },
  options: [],
};

export default defaultReducer("REVENUE_TERMS_REDUCER", defaultState);
